import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import Alert from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Alert';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import AlertTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AlertTitle';

const styles = (theme) => ({
  root: {
    borderRadius: theme.radius.md,
  },
  alertTitle: {},
  message: {},
});

/**
 * @deprecated Use the Alert from Packages/FacetDesign/Alert instead
 */
const BasicAlert = ({
  className,
  classes,
  message,
  severity,
  title,
  AlertProps,
  test,
  AlertTitleProps,
}) => {
  return (
    <Alert
      classes={{
        root: classNames(classes.root, className),
      }}
      severity={severity}
      test={test}
      {...AlertProps}
    >
      <AlertTitle
        className={classes.alertTitle}
        {...AlertTitleProps}
      >
        <Typography
          className={classes.message}
          variant={'h5'}
          weight={'bold'}
          color={'inherit'}
        >
          {title}
        </Typography>
      </AlertTitle>
      <Typography
        className={classes.message}
        variant={'body1'}
        color={'inherit'}
      >
        {message}
      </Typography>
    </Alert>
  );
};

BasicAlert.defaultProps = {
  className: '',
  severity: 'info',
  title: null,
  test: 'alert',
  message: '',
};

BasicAlert.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
  severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
  title: PropTypes.string,
  test: PropTypes.string,
};

export default withStyles(styles)(BasicAlert);
